module.exports = __webpack_public_path__ + "img/126.d2119ec7.jpg";